import { Model } from "@vuex-orm/core";

export default class EproProgramDefinition extends Model {
  static entity = "eproProgramDefinitions";

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      description: this.attr(null),
      assignedBundle: this.attr([]),
    };
  }

  static async getProgramDefinitions() {
    return await this.api().get("program-definition", {
      dataKey: "result",
    });
  }
}
